const BASE_URL = process.env.REACT_APP_BASE_URL || '';

const authHeaders = (extra = {}) => {
  const token = localStorage.getItem('token');
  return { ...(token && { Authorization: `Bearer ${token}` }), ...extra };
};

async function fetchWithTimeout(url, options = {}, timeout = 10000) {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);
  try {
    const res = await fetch(url, { signal: controller.signal, ...options });
    return res;
  } finally {
    clearTimeout(id);
  }
}

export async function getRecommendations(timeout = 100000) {
  const url = `${BASE_URL}/api/recommendations`;
  const res = await fetchWithTimeout(url, { method: 'GET', headers: authHeaders() }, timeout);
  if (!res.ok) throw new Error(`Failed to fetch recommendations: ${res.status}`);
  return res.json();
}

export async function getRecommendationsByItemId(itemId, timeout = 10000) {
  const url = `${BASE_URL}/api/recommendations/item/${itemId}`;
  const res = await fetchWithTimeout(url, { method: 'GET', headers: authHeaders() }, timeout);
  if (!res.ok) throw new Error(`Failed to fetch recommendations: ${res.status}`);
  return res.json();
}

export async function submitRecommendation({ orderId, itemId, name, text }) {
  const res = await fetch(`${BASE_URL}/api/recommendations`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ orderId, itemId, name, text }),
  });
  if (!res.ok) throw new Error(`Failed: ${res.status}`);
  return res.json();
}

export async function getAllRecommendations() {
  const res = await fetch(`${BASE_URL}/api/recommendations/pending`, {
    method: 'GET',
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error(`Failed: ${res.status}`);
  return res.json();
}

export async function approveRecommendation(id) {
  const res = await fetch(`${BASE_URL}/api/recommendations/${id}/approve`, {
    method: 'PATCH',
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error(`Failed: ${res.status}`);
  return res.json();
}

export async function updateRecommendation(id, { name, text, itemId, status }) {
  const res = await fetch(`${BASE_URL}/api/recommendations/${id}`, {
    method: 'PATCH',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ name, text, itemId, status }),
  });
  if (!res.ok) throw new Error(`Failed: ${res.status}`);
  return res.json();
}

export async function deleteAdminItem(id) {
  const res = await fetch(`${BASE_URL}/api/items/admin/${id}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error(`Failed: ${res.status}`);
  return res.json();
}

export async function createAdminItem(data) {
  const res = await fetch(`${BASE_URL}/api/items/admin`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error(`Failed: ${res.status}`);
  return res.json();
}

export async function getAdminItems() {
  const res = await fetch(`${BASE_URL}/api/items/admin/all`, {
    method: 'GET',
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error(`Failed: ${res.status}`);
  return res.json();
}

export async function getItemBuyers(id) {
  const res = await fetch(`${BASE_URL}/api/items/admin/${id}/buyers`, {
    method: 'GET',
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error(`Failed: ${res.status}`);
  return res.json();
}

export async function updateAdminItem(id, data) {
  const res = await fetch(`${BASE_URL}/api/items/admin/${id}`, {
    method: 'PUT',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error(`Failed: ${res.status}`);
  return res.json();
}

export async function getUserDetails(id) {
  const res = await fetch(`${BASE_URL}/api/users/${id}/details`, {
    method: 'GET',
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error(`Failed: ${res.status}`);
  return res.json();
}

export async function getUsers() {
  const res = await fetch(`${BASE_URL}/api/users`, {
    method: 'GET',
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error(`Failed: ${res.status}`);
  return res.json();
}

export async function getFilterTable(table) {
  const res = await fetch(`${BASE_URL}/api/filters/admin/${table}`, {
    method: 'GET', headers: authHeaders(),
  });
  if (!res.ok) throw new Error(`Failed: ${res.status}`);
  return res.json();
}

export async function addFilterRow(table, name) {
  const res = await fetch(`${BASE_URL}/api/filters/admin/${table}`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ name }),
  });
  if (!res.ok) throw new Error(`Failed: ${res.status}`);
  return res.json();
}

export async function deleteFilterRow(table, id) {
  const res = await fetch(`${BASE_URL}/api/filters/admin/${table}/${id}`, {
    method: 'DELETE', headers: authHeaders(),
  });
  if (!res.ok) throw new Error(`Failed: ${res.status}`);
  return res.json();
}

const recommendationAPI = { getRecommendations, getRecommendationsByItemId, submitRecommendation, getAllRecommendations, approveRecommendation, updateRecommendation, getUsers };
export default recommendationAPI;
